import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { ImageRequest } from 'src/app/model/imageRequest/imageRequest';
import { EndpointConfig } from 'src/app/config/endpoint-config';
import { from, Observable } from 'rxjs';
import { concatMap, toArray } from 'rxjs/operators';


export interface ImageRequestRegisterModel {
        src: string;
        reasonCode: string;
        comment: string;
        requestDetail: {
            [key: string]: any;
        };
}

export interface ImageRequestRegisterData {
    ok: boolean;
    imageRequests: ImageRequestRegisterModel[];
}

interface ReasonDto{
    reasonCode: string;
    reasonText: string;
}

interface ReasonResponse{
    reasons: ReasonDto[];
    totalCount: number;
}

@Component({
    selector: 'app-image-request-register-dialog',
    templateUrl: './image-request-register-dialog.component.html',
})
export class ImageRequestRegisterDialogComponent implements OnInit {
    reasonForm: FormGroup;
    commentForm: FormGroup;
    moveForm: FormGroup;
    reasonList: Array<{ reason_code: string; reason_text: string }> = [];

    constructor(
        private fb: FormBuilder,
        private http: HttpClient,
        private endpoint: EndpointConfig,
        public dialogRef: MatDialogRef<ImageRequestRegisterDialogComponent, ImageRequestRegisterData>,
        @Inject(MAT_DIALOG_DATA) public data: ImageRequestRegisterModel[]
    ) {
        this.reasonForm = this.fb.group({
            reason_code: ['', Validators.required]
        });
        this.moveForm = this.fb.group({
            from: ['', Validators.required],
            to: ['', Validators.required]
        });
        this.commentForm = this.fb.group({
            comment: ['']
        });
    }

    ngOnInit(): void {
        const url = this.endpoint.riaApi.imageRequests.reasons.getUrl();
        this.http.get<ReasonResponse>(url).subscribe(
            (res) => {
                const reasons = (res && res.reasons) ? res.reasons : [];
                this.reasonList = reasons.map(function(r) {
                    return {
                        reason_code: r.reasonCode,
                        reason_text: r.reasonText,
                    };
                });
            },
            (err) => {
                console.error('Failed to load reasons', err);
            }
        );
    }

    getReasonText(code: string): string {
        const reason = this.reasonList.find(r => r.reason_code === code);
        return reason ? reason.reason_text : '';
    }

    sendRequest(): void {
        let payloads = this.data.map(imageRequest => {
            let requestDetail = imageRequest.requestDetail;
            // reason_codeが'move-image'の場合、moveFormの値を追加
            if (this.reasonForm.value.reason_code === 'move-image') {
                requestDetail.from = this.moveForm.value.from;
                requestDetail.to = this.moveForm.value.to;
            }
            return {
                src: imageRequest.src,
                reasonCode: this.reasonForm.value.reason_code,
                comment: this.commentForm.value.comment,
                requestDetail: requestDetail
            };
        });

        console.info('Image Request Payloads:', payloads);

        // payloadsを返し、実際の登録は呼び出し元で行う。
        this.ok(payloads);
    }

    ok(payloads: ImageRequestRegisterModel[]) {
        this.dialogRef.close({
            ok: true,
            imageRequests: payloads
        })
    }

    cancel() {
        this.dialogRef.close({
            ok: false,
            imageRequests: []
        })
    }
}